import classnames from 'classnames'
import React from 'react'
import analyticsConstants from '../analytics/analytics.constants'
import { SIZE_BIG } from '../genericComponents/buttons/RectangleActionButton'
import { withFrenchSite } from '../i18n/i18nSite'
import devicePng from './assets/device.png'
import deviceWebp from './assets/device.webp'
import s from './AutoPromoGE.less'
import AutoPromoOpenButton from './AutoPromoOpenButton'
import ImageWithFallback from '../ui/ImageWithFallback'

const AutoPromoGE = ({ className }) => {
  return (
    <div className={classnames(className, s.wrapper)}>
      <div className={s.content}>
        <ImageWithFallback className={s.device} image={deviceWebp} fallbackImage={devicePng} width="102" height="142" />
        <div>
          <div className={s.title}>{'Tout Mappy dans votre poche'}</div>
          <p className={s.text}>{'Un GPS efficace et gratuit, trafic en temps réel et alertes de vitesse'}</p>
          <div className={s.infos}>
            <AutoPromoOpenButton size={SIZE_BIG} area={analyticsConstants.autopromo.area.main} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default withFrenchSite(AutoPromoGE)
